"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.packageGatePlanId = packageGatePlanId;
exports.packageGatePlanLabel = packageGatePlanLabel;
exports.packageGateBadgeTone = packageGateBadgeTone;
exports.packageGateInactiveSettingsBanner = packageGateInactiveSettingsBanner;
exports.packageGateUpgradeDescription = packageGateUpgradeDescription;
function packageGatePlanId(gate) {
    return gate === 4 ? 'business' : 'pro';
}
function packageGatePlanLabel(gate) {
    return gate === 4 ? 'Business' : 'Pro';
}
/** Badge tone στο frontend (Basic = violet, Pro = emerald, Business = gold). */
function packageGateBadgeTone(gate) {
    return gate === 4 ? 'gold' : 'emerald';
}
function packageGateInactiveSettingsBanner(gate) {
    const plan = packageGatePlanLabel(gate);
    if (gate === 2) {
        return `Το πακέτο ${plan} δεν είναι ενεργό για τον λογαριασμό σας. Οι ρυθμίσεις παρακάτω περιλαμβάνουν μόνο τα βασικά στοιχεία επιχείρησης.`;
    }
    return `Απαιτείται πακέτο ${plan}.`;
}
function packageGateUpgradeDescription(gate) {
    const plan = packageGatePlanLabel(gate);
    if (gate === 4) {
        return 'Αναφορές, analytics και εξαγωγές απαιτούν πακέτο Business.';
    }
    return `Η λειτουργία απαιτεί πακέτο ${plan} ή ανώτερο.`;
}
